import { render, staticRenderFns } from "./FreemiumModalWithVideo.vue?vue&type=template&id=2104c840&scoped=true&"
import script from "./FreemiumModalWithVideo.vue?vue&type=script&lang=ts&"
export * from "./FreemiumModalWithVideo.vue?vue&type=script&lang=ts&"
import style0 from "./FreemiumModalWithVideo.vue?vue&type=style&index=0&id=2104c840&prod&lang=css&"
import style1 from "./FreemiumModalWithVideo.vue?vue&type=style&index=1&id=2104c840&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2104c840",
  null
  
)

export default component.exports